import api from './api';
import { 
  NewsletterSubscriber, 
  NewsletterSubscriberCreate, 
  NewsletterSubscriberUpdate,
  NewsletterListParams 
} from '@/types';

class NewsletterService {
  async subscribe(subscriberData: NewsletterSubscriberCreate): Promise<NewsletterSubscriber> {
    const response = await api.post<NewsletterSubscriber>('/api/newsletter/subscribe', subscriberData);
    return response.data;
  }

  async unsubscribe(email: string): Promise<{ message: string }> {
    const response = await api.post('/api/newsletter/unsubscribe', { email });
    return response.data;
  }

  async getSubscribers(params: NewsletterListParams = {}): Promise<NewsletterSubscriber[]> {
    const response = await api.get<NewsletterSubscriber[]>('/api/newsletter/subscribers', { params });
    return response.data;
  }

  async getSubscriberCount(activeOnly: boolean = true): Promise<{ count: number; active_only: boolean }> {
    const response = await api.get('/api/newsletter/subscribers/count', { 
      params: { active_only: activeOnly } 
    });
    return response.data;
  }

  async updateSubscriber(id: number, subscriberData: NewsletterSubscriberUpdate): Promise<NewsletterSubscriber> {
    const response = await api.put<NewsletterSubscriber>(`/api/newsletter/subscribers/${id}`, subscriberData);
    return response.data;
  }

  async deleteSubscriber(id: number): Promise<{ message: string }> {
    const response = await api.delete(`/api/newsletter/subscribers/${id}`);
    return response.data;
  }
}

export const newsletterService = new NewsletterService();